import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { IZonaCiudad } from './interfaces/zona-ciudad.interface';
import { ZonaCiudadService } from './services/zona-ciudad.service';

@Component({
  selector: 'app-zona-ciudad-list',
  templateUrl: './zona-ciudad-list.component.html',
  providers: [MessageService]
})
export class ZonaCiudadListComponent implements OnInit, OnChanges {
  @ViewChild('dt') table!: Table;

  @Input() displayDialog: boolean = false;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{ refresh: boolean }>();
  @Input() zona: string | null = null;

  dataSource: IZonaCiudad[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'claveCd', header: 'Clave Ciudad', sortable: true },
    { field: 'ciu_mun_del', header: 'Nombre Ciudad', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  displayNuevoDialog: boolean = false;
  ciudadSeleccionada: IZonaCiudad | null = null;

  constructor(
    private messageService: MessageService,
    private zonaCiudadService: ZonaCiudadService
  ) {}

  ngOnInit(): void {
    // No llamar a loadData aquí para evitar doble ejecución
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['displayDialog'] && changes['displayDialog'].currentValue === true) || (changes['zona'] && this.displayDialog)) {
      if (this.zona) {
        this.loadData();
      }
    }
  }

  loadData(): void {
    if (!this.zona) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.loading = true;
    this.zonaCiudadService.getCiudadesPorZona(this.zona).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data.map((item: any) => ({
            claveCd: item.claveCd,
            ciu_mun_del: item.ciu_mun_del,
            zona: item.zona,
            descZona: item.descZona
          }));
          this.totalRecords = this.dataSource.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las ciudades'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las ciudades'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }

  openNuevo(): void {
    this.ciudadSeleccionada = null;
    this.displayNuevoDialog = true;
  }

  editarCiudad(ciudad: IZonaCiudad): void {
    this.ciudadSeleccionada = ciudad;
    this.displayNuevoDialog = true;
  }

  eliminarCiudad(ciudad: any): void {
    if (!this.zona || !ciudad.claveCd) return;
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la ciudad ${ciudad.ciu_mun_del}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        iconColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.zonaCiudadService.deleteCiudad(this.zona, ciudad.claveCd).subscribe({
            next: (response) => {
              if (response.success) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Ciudad eliminada correctamente'
                });
                this.loadData();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No se pudo eliminar la ciudad'
                });
              }
            },
            error: (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar la ciudad'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }

  onNuevoCiudadGuardada(event: { success: boolean; message: string }): void {
    this.displayNuevoDialog = false;
    this.ciudadSeleccionada = null;
    if (event.success) {
      this.loadData();
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
    }
  }

  onNuevoDialogClosed(): void {
    this.displayNuevoDialog = false;
    this.ciudadSeleccionada = null;
  }
} 